import React from 'react';
import { Field, reduxForm } from 'redux-form';

const validate = values => {
  const errors = {};
  if (!values.url) {
    errors.url = 'Required';
  } else if (
    !/^((http[s]?|ftp):\/)?\/?([^:\/\s]+)((\/\w+)*\/)([\w\-\.]+[^#?\s]+)(.*)?(#[\w\-]+)?$/.test(
      values.url
    )
  ) {
    errors.url = 'Invalid url';
  }
  return errors;
};

const renderField = ({
  input,
  label,
  type,
  value,
  meta: { touched, error, warning }
}) => (
  <div className="field">
    <label>{label}</label>
    <input
      {...input}
      placeholder={label}
      type={type}
      style={{ width: '100%' }}
    />
    {touched &&
      ((error && <div className="ui pointing red basic label">{error}</div>))}
  </div>
);

let UrlForm = props => {
  const { handleSubmit, submitting } = props;

  return (
    <section className="ui basic text container segment">
      <form className="ui form" onSubmit={handleSubmit}>
        <Field
          component={renderField}
          label="IIIF Manifest Url"
          type="text"
          name="url"
          placeholder="IIIF Manifest Url"
        />
        <button className="ui button" type="submit" disabled={submitting}>
          Submit
        </button>
      </form>
    </section>
  );
};

export default (UrlForm = reduxForm({
  form: 'manifest',
  validate
})(UrlForm));



// WEBPACK FOOTER //
// ./src/components/UrlForm.js